export class EventsModel {
  eventId: string;
  eventName: string;
  eventStartDate: string;
  eventEndDate: string;
  eventVenue: string;
  country: string;
  image: string;
  createConference:string;


  constructor() {
    this.eventId = "";
    this.eventName = "";
    this.eventStartDate = "";
    this.eventEndDate = "";
    this.eventVenue = "";
    this.country = "";
    this.image="";
    this.createConference=""

  }
}




